import { Box, Grid } from "@mui/material";
import { IDialogContextGeneric } from "../../../../../../components/BasicComponents/GenericModalContext";
import DialogFullScreen from "../../../../../../components/DialogFullScreen";
import axiosClient from "../../../../../../lib/axios";
import { useQuery } from "react-query";
import { IDetalheProdutoEstoque } from "../../../../../../types/api/estoque/detalhar-produto-estoque";
import DetalheProdSkeleton from "./DetalheProdSkeleton";
import CardInformacoesPrincipais from "./CardInformacoesPrincipais";
import CardInformacoesLojas from "./CardInformacoesLojas";
import CardUltimasCompras from "./CardUltimasCompras";
import CardUltimasVendas from "./CardUltimasVendas";
import CardUltimasVendasMensais from "./CardUltimasVendasMensais";
import CardInformacoesBasicas from "./CardInformacoesBasicas";
import CardEspecificacoesTecnicas from "./CardEspecificacoesTecnicas";
import CardDadosAdicionais from "./CardDadosAdicionais";
import { usePermission } from "../../../../../../components/PermissionGuard";
import AlertDisplay from "../../../../../../components/BasicComponents/DisplayDados/AlertDisplay";
import { useState } from "react";
import DialogEditInformacoesBasicas from "./CardInformacoesBasicas/DialogEditInformacoesBasicas";
export default function DialogDetalheProduto({
    open,
    value,
    handleClose
}: IDialogContextGeneric<string>) {

    const [openCategoriaModal, setOpenCategoriaModal] = useState(false);

    const handleOpenCategoriaModal = () => {
        setOpenCategoriaModal(true);
    };

    const handleCloseCategoriaModal = () => {
        setOpenCategoriaModal(false);
    };

    const hasPermissionCompras = usePermission("estoque.detalhar-produto.ultimas-compras")
    const hasPermissionVendas = usePermission("estoque.detalhar-produto.ultimas-vendas")
    const hasPermissionInformacoesProduto = usePermission("estoque.detalhar-produto.informacoes-produto")
    const hasPermissionVendasMensais = usePermission("estoque.detalhar-produto.vendas-mensais")

    const { data, isLoading } = useQuery({
        queryKey: ['detalhe-produto', value],
        queryFn: () => axiosClient.get(`/estoque/produtos/detalhar/${value}`),
    });

    const produto: IDetalheProdutoEstoque | null = data?.data || null;
    const carregando = isLoading || !produto;
    const temCategoria = produto?.categorias?.[0] !== undefined;

    return (
        <>
            <DialogFullScreen
                {...{ open, handleClose }}
                title="Detalhe do Produto"
            >
                {!carregando && !temCategoria && (
                    <Box px={2}>
                        <AlertDisplay
                            color="warning"
                            registro="Este produto não tem categoria vinculada, clique no botão para vincular uma a este produto"
                            titulo="Registro de categorias"
                            acao="Vincular categoria"
                            acaoCallback={handleOpenCategoriaModal}
                        />
                    </Box>
                )}
                {carregando && <DetalheProdSkeleton />}
                {!carregando && (
                    <Box p={2}>
                        <Grid container spacing={3}>
                            <Grid size={{ xs: 12, md: 4 }}>
                                <Grid container spacing={3}>
                                    <Grid size={{ xs: 12 }}>
                                        <CardInformacoesPrincipais
                                            produtoId={produto.id}
                                            ativo={produto.ativo}
                                            codigo={produto.id}
                                            nome={produto.nome}
                                            unidadeMedida={produto.unidade_medida?.sigla ?? ''}
                                            estoqueAtual={produto.estoque_total || 0}
                                            custoMedio={produto.custo_medio || 0}
                                            precoVenda={produto.preco_venda || 0}
                                            estoqueDisponivelVendas={produto.estoque_disponivel_vendas_total || 0}
                                            comprasAReceber={produto.compras_a_receber || 0}
                                            pedidosAEntregar={produto.pedidos_a_entregar || 0}
                                            disponivelTotal={produto.disponivel_total || 0}
                                            imagemUrl={produto.imagem?.[0]?.url}
                                        />
                                    </Grid>
                                    {hasPermissionCompras && (
                                        <Grid size={{ xs: 12 }}>
                                            <CardUltimasCompras produtoId={produto.id} />
                                        </Grid>
                                    )}
                                    {hasPermissionVendas && (
                                        <Grid size={{ xs: 12 }}>
                                            <CardUltimasVendas produtoId={produto.id} />
                                        </Grid>
                                    )}
                                </Grid>
                            </Grid>
                            <Grid size={{ xs: 12, md: 8 }}>
                                <Grid container spacing={3}>
                                    <Grid size={{ xs: 12 }}>
                                        <CardInformacoesBasicas
                                            produto={produto}
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 12 }}>
                                        <CardEspecificacoesTecnicas
                                            produto={produto}
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 12 }}>
                                        <CardDadosAdicionais
                                            produto={produto}
                                        />
                                    </Grid>
                                    {hasPermissionInformacoesProduto && (
                                        <Grid size={{ xs: 12 }}>
                                            <CardInformacoesLojas
                                                produtoLoja={produto.produto_lojas}
                                            />
                                        </Grid>
                                    )}
                                    {hasPermissionVendasMensais && (
                                        <Grid size={{ xs: 12 }}>
                                            <CardUltimasVendasMensais
                                                produtoId={produto.id}
                                            />
                                        </Grid>
                                    )}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                )}
            </DialogFullScreen>
            {produto && (
                <DialogEditInformacoesBasicas
                    open={openCategoriaModal}
                    onClose={handleCloseCategoriaModal}
                    produto={produto}
                />
            )}
        </>
    );
}